<script setup lang="ts">
const { t } = useI18n();
const { modalOpen, consent, save, acceptAll, refuseAll, closeModal } = useCookieConsent();

const analyticsValue = ref(false);
const mapboxValue = ref(false);

watch(modalOpen, (open) => {
  if (open) {
    analyticsValue.value = consent.value?.analytics ?? false;
    mapboxValue.value = consent.value?.mapbox ?? false;
  }
});

function onSave() {
  save({ analytics: analyticsValue.value, mapbox: mapboxValue.value });
  closeModal();
}

function onAcceptAll() {
  acceptAll();
  closeModal();
}

function onRefuseAll() {
  refuseAll();
  closeModal();
}

const ui = {
  content: "sm:max-w-lg",
};
</script>

<template>
  <UModal v-model:open="modalOpen" :title="t('cookies.modal.title')" :transition="false" :ui="ui">
    <template #body>
      <div class="flex flex-col gap-10">
        <p class="text-base/snug">{{ t("cookies.modal.intro") }}</p>

        <fieldset class="flex flex-col gap-6">
          <legend class="sr-only">{{ t("cookies.modal.title") }}</legend>

          <USwitch
            v-model="analyticsValue"
            color="primary"
            :label="t('cookies.analytics.title')"
            :description="t('cookies.analytics.description')"
            :ui="{ wrapper: 'ms-3', label: 'text-base font-semibold', description: 'mt-1' }"
          />

          <USwitch
            v-model="mapboxValue"
            color="primary"
            :label="t('cookies.mapbox.title')"
            :description="t('cookies.mapbox.description')"
            :ui="{ wrapper: 'ms-3', label: 'text-base font-semibold', description: 'mt-1' }"
          />
        </fieldset>
      </div>
    </template>

    <template #footer>
      <div class="flex flex-wrap gap-2 gap-x-4 w-full justify-start">
        <div class="flex gap-2 gap-x-4">
          <UButton color="secondary" @click="onSave">
            {{ t("cookies.save") }}
          </UButton>
          <UButton variant="outline" @click="onAcceptAll">
            {{ t("cookies.acceptAll") }}
          </UButton>
          <UButton variant="link" class="px-1.5" @click="onRefuseAll">
            {{ t("cookies.refuseAll") }}
          </UButton>
        </div>
      </div>
    </template>
  </UModal>
</template>
